import React, { useId } from 'react';
import { Input, Label } from 'reactstrap';
import { formatPrice } from '../../helpers/utility';
import { billableQuantity } from '../../helpers/purchaseQuantities';

export default function SupplierArticleItem({ row, item, quantityField, stock, disabled, onSelect, onChange }) {
    const id = useId();
    const selected = Boolean(item);
    const quantity = Number(item?.[quantityField] || 0);
    const free = Number(item?.quantiteGratuite || 0);
    return <div className={`supplier-item-row ${selected ? 'is-selected' : ''}`}>
        <div className="supplier-item-name">
            <Input id={`${id}-selected`} type="checkbox" checked={selected} disabled={disabled} onChange={onSelect} />
            <div><Label for={`${id}-selected`}>{row.articleLibelle}</Label>
                <small data-testid="available-stock">En stock : <strong>{stock ?? '…'}</strong>{row.unite ? ` · ${row.unite}` : ''}</small>
            </div>
        </div>
        <div><Label for={`${id}-quantity`}>Quantité</Label><Input id={`${id}-quantity`} name={quantityField} type="number" min="0.001" step="0.001"
            disabled={disabled || !selected} value={selected ? item[quantityField] : ''} placeholder="—" onFocus={event => event.target.select()} onChange={onChange} /></div>
        <div><Label for={`${id}-price`}>Prix unitaire</Label><Input id={`${id}-price`} name="prixUnitaireTTC" type="number" min="0" step="0.01"
            disabled={disabled || !selected} value={selected ? item.prixUnitaireTTC : Number((Number(row.prixAchatHT || 0) * (1 + Number(row.tauxTVAAchat ?? 0.2))).toFixed(2))} onChange={onChange} /></div>
        <div className="supplier-item-total"><span>Total</span><strong>{selected ? formatPrice(item.montantTTC) : '—'}</strong></div>
        {selected && <details className="supplier-item-free" open={free > 0 ? true : undefined}>
            <summary>Des unités gratuites ?{free > 0 ? ` (${free})` : ''}</summary>
            <div><Label for={`${id}-free`}>Dont gratuites</Label><Input id={`${id}-free`} name="quantiteGratuite" type="number" min="0" max={quantity} step="0.001" value={item.quantiteGratuite ?? 0}
                disabled={disabled} invalid={free < 0 || free > quantity} onChange={onChange} />
                <small>{free < 0 || free > quantity ? `Indiquez un nombre entre 0 et ${quantity}.` : `${quantity} au total : ${billableQuantity(quantity, free)} à payer et ${free} gratuites, rangées à part.`}</small>
            </div>
        </details>}
    </div>;
}
